export default __webpack_public_path__ + "media/images/dashboard/analytics-450a5a5a5c547281639064ce0ed52081.svg";